<div class="wrapper">
	<header>
		<div class="time-header" *ngFor="let time of times">{{ time }}</div>
	</header>
	<div class="body">
		<div class="time" *ngFor="let workflow of Values">{{ workflow.calendar.name }}</div>
	</div>
</div>
